export default __webpack_public_path__ + "static/media/Afacad-Bold.7bf00400.ttf";